import Swiper from 'swiper';

//モジュールのインポート
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css';

export function swiperFunc() {
  // ファーストビューのSwiper（フェード効果）
  const fvSwiper = new Swiper(".fv-swiper", {
    modules: [Autoplay, EffectFade, Pagination],
    loop: true,
    speed: 3000,
    effect: 'fade',
    slidesPerView: 1,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
    }
  });

  // 商品スライダーのSwiper
  const swiper = new Swiper(".swiper", {
    modules: [Autoplay],
    loop: true,
    speed: 1500,
    slidesPerView: 3,
    spaceBetween: 10,
    autoplay: true,
    breakpoints: {
      767: {
        slidesPerView: 3.5,
        spaceBetween: 40,
      }
    }
  });

  document.querySelector(".swiper_pause").addEventListener("click", function(){
	//.paused があるとき
	if(this.classList.contains("paused")){
		swiper.autoplay.start(); //再生
		swiper.allowTouchMove = true; //タッチ操作を有効化
		this.classList.remove("paused"); //.paused 削除
		// アイコンを停止アイコンに変更
		this.querySelector("img").src = this.querySelector("img").src.replace("slide_start.svg", "slide_stop.svg");
	}else{
		//.paused が無いとき
		swiper.autoplay.stop(); //一時停止
		swiper.allowTouchMove = false; //タッチ操作を無効化
		this.classList.add("paused"); //.paused 付与
		// アイコンを再生アイコンに変更
		this.querySelector("img").src = this.querySelector("img").src.replace("slide_stop.svg", "slide_start.svg");
	}
});
}
